import PubSub from "underpub-js";
import OverlayScrollBars from "overlayscrollbars/js/jquery.overlayScrollbars.js";
import gsap from 'gsap';

var ListingFloorPlan = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingFloorPlan',
	};

	$.extend(true, this.options, options);

};

ListingFloorPlan.prototype.init = function() {

	var self = this;

	this.$modal = self.options.$el.find(`.${self.options.baseClass}__modal`);
	this.$modalCloseX = self.options.$el.find(`.${self.options.baseClass}__closeX`);
	this.$modalCloseXSpans = this.$modalCloseX.find(`span`);
	this.$modalImage = this.$modal.find(`.${self.options.baseClass}__image`);

	this.$openModalButton = self.options.$el.find(`.${self.options.baseClass}__contentColumn .${self.options.baseClass}__cta div`);

	this.initAnimationTimelines();

	this.$openModalButton.on('click', function() {
		self.show();
	});

	this.$modalCloseX.on('click', function() {
		self.hide();
	});

};

ListingFloorPlan.prototype.initAnimationTimelines = function(){

	var self = this;

	this.modalInTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	// show nav
	.set(self.$modal,
		{
			visibility: 'visible',
			zIndex: 1001
		}
	)
	.to(self.$modal,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
			//ease: "power1.out",
		}
	)
	// image
	.fromTo(self.$modalImage,
		{
			opacity: 0,
			y: 20
		},
		{
			ease: "power1.out",
			duration: 0.45,
			opacity: 1,
			y: 0
		}
	)
	// close x
	.from(self.$modalCloseXSpans,
		{
			duration: 0.35,
			width: 0,
			ease: "power3.out"
		}
	)
	.from(self.$modalCloseXSpans,
		{
			duration: 0.35,
			rotate: 0,
			ease: "power1.inOut"
		},
		">-0.1"
	)
	;

	this.modalOutTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	.to(self.$modalCloseXSpans,
		{
			duration: 0.35,
			rotate: 0,
			ease: "power1.inOut"
		}
	)
	.to(self.$modalCloseXSpans,
		{
			duration: 0.35,
			width: 0,
			ease: "power3.in"
		},
		">-0.1"
	)
	.to(self.$modal,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 0,
		},
		">-0.1"
	)
	.set(self.$modal,
		{
			visibility: 'hidden',
			zIndex: -1,
		}
	)
	;

};

ListingFloorPlan.prototype.show = function(){

	var self = this;

	this.modalInTimeline.restart();

};

ListingFloorPlan.prototype.hide = function(){

	var self = this;

	this.modalOutTimeline.restart();

};

export default ListingFloorPlan;
